import { render, staticRenderFns } from "./JourneyDetail.vue?vue&type=template&id=19a99246&scoped=true&"
import script from "./JourneyDetail.vue?vue&type=script&lang=js&"
export * from "./JourneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./JourneyDetail.vue?vue&type=style&index=0&id=19a99246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a99246",
  null
  
)

export default component.exports